import { useContext } from "react";

import { LocalizationContext } from "../contexts/LocalizationProvider";

export function useCurrency() {
    return useContext(LocalizationContext).currency;
}
